/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 03-08-2020.
 */
import React from 'react'

import './spinner.scss'
import { COLOR_PRIMARY } from '../../constants'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

const Spinner = ({ size = 50, style = {} }) => {
  return <div className="loader" style={{ color: COLOR_PRIMARY, fontSize: size, ...style }}></div>
}

export const RoundSpinner = ({ size = 50, className = '', style = {} }) => {
  return (
    <Spin
      className={className}
      indicator={<LoadingOutlined style={{ fontSize: size, animationDuration: '0.5s' }} spin />}
    />
  )
  //return <LoadingOutlined className="mt-4" style={{ fontSize: size }} />
}

export default Spinner
